import { IBaseResponse } from "@nkr/models/base-response";
import { IAccountsPayable, IAccountsPayableDetail } from "@nkr/models/reports";
import { AuthActionCreators } from "@nkr/store/authorization";
import { useAppHookContext } from "@nkr/utils/rest-api/useAppHookContext";
import { useEffect, useState } from "react";

interface IRetVal {
    list: IAccountsPayableDetail[],
    loading: boolean, 
    error: string,
    setChecked: (detail: IAccountsPayableDetail) => void,
    checkPayNow: () => void,
    isPayable: boolean
}

function useAPDetails(ap: IAccountsPayable, show: boolean): IRetVal {
    const { dispatch } = useAppHookContext();
    const [loading, setLoading] = useState<boolean>(false);
    const [error, setError] = useState<string>('');
    const [list, setList] = useState<IAccountsPayableDetail[]>([]);
    const isPayable = ap.confirmationAmount == ap.payNow && !!ap.confirmationNumber;

    useEffect(() => {
        setLoading(true);
        setError('');

        const fetchData = async () => {
            var config = {
                url: `${__API_BASE_}/admin/billing-report/accounts-payable/${ap.centerId}`
            };

            try {
                const response: IBaseResponse = await dispatch(AuthActionCreators.apiGet(config));
                
                if (response && response.data.results && response.data.success) {
                    setList(response.data.results);    
                    if (isPayable)
                        checkPayNow();
    
                } else {
                    setError('Unable to load data');
                    setList([]);     
                }
            } catch (err) {
                setList([]);
                setError(err);
            } finally {
                setLoading(false);
            }
        }

        if (ap && show) {
            fetchData();
        }
    }, [ap, show]);

    const setChecked = (detail: IAccountsPayableDetail) => {
        if(!isPayable) {
            const clone = list.map((v) => {
                if( v.donorAlias == detail.donorAlias && v.billingType == detail.billingType ) {
                    return { ...v, isChecked: !detail.isChecked }
                }
                
                return v;
            });
            
            setList(clone);
        }
    }

    const checkPayNow = () => {
        setList(current => current.map((v) => {
            return { ...v, isChecked: ap.payAfterDayNumber && ap.payAfterDayNumber > 0 && v.daysOutstanding >= ap.payAfterDayNumber}
        }));
    }
    

    return { list, error, loading, setChecked, checkPayNow, isPayable };
}

export default useAPDetails;
